<div class="card inner-shadow">
  <div class="card-body">
    <div class="header">
      <div class="left-header">
        <p class="title text-left">{{ 'Thread' | translate }} {{ index }}</p><small>{{ data.created_at | date:'yyyy / M / d' }}</small>
      </div>
      <div class="right-header">
        <div class="avatar" [style.backgroundImage]="'url(assets/images/avatar.png)'"></div>
        <div class="avatar" [style.backgroundImage]="'url(assets/images/avatar.png)'"></div>
        <div class="avatar" [style.backgroundImage]="'url(assets/images/avatar.png)'"></div>
      </div>
    </div>
    <div class="details">
      <table>
        <tr>
          <th>{{'Annotation ID' | translate}}</th>
          <td>{{ data.annotation.id }}</td>
        </tr>
        <tr>
          <th>{{'Annotation Name' | translate}}</th>
          <td>{{ data.annotation.name }}</td>
        </tr>
      </table>
    </div>
  </div>
</div>